// extracted by mini-css-extract-plugin
export default {"reportsPageWrapper":"ReportsPage_reportsPageWrapper__jBdWc"};